/** Tori-Todo와 동일: AES-GCM + env passphrase. 미설정 시 평문(개발용). */
const ENCRYPTION_PREFIX = 'enc:v1:'
const IV_LENGTH = 12

function getPassphrase(): string | undefined {
  const p = import.meta.env.VITE_SYNC_PASSPHRASE as string | undefined
  console.log('[DEBUG-CRYPTO] Current Key:', p ? p.substring(0, 4) + '...' : 'NULL');
  return p?.trim() || undefined
}

async function getAesKey(): Promise<CryptoKey> {
  const passphrase = getPassphrase()
  if (!passphrase) {
    throw new Error('VITE_SYNC_PASSPHRASE가 필요합니다.')
  }
  const encoder = new TextEncoder()
  const keyMaterial = encoder.encode(passphrase)
  const digest = await crypto.subtle.digest('SHA-256', keyMaterial)
  return crypto.subtle.importKey('raw', digest, { name: 'AES-GCM' }, false, ['encrypt', 'decrypt'])
}

function bytesToBase64(bytes: Uint8Array): string {
  let binary = ''
  bytes.forEach((b) => {
    binary += String.fromCharCode(b)
  })
  return btoa(binary)
}

function base64ToBytes(base64: string): Uint8Array {
  const binary = atob(base64)
  const bytes = new Uint8Array(binary.length)
  for (let i = 0; i < binary.length; i++) {
    bytes[i] = binary.charCodeAt(i)
  }
  return bytes
}

export async function encryptSyncJson(plainText: string): Promise<string> {
  if (!plainText) return plainText
  if (!getPassphrase()) {
    return plainText
  }
  const key = await getAesKey()
  const iv = crypto.getRandomValues(new Uint8Array(IV_LENGTH))
  const data = new TextEncoder().encode(plainText)
  const encryptedBuffer = await crypto.subtle.encrypt({ name: 'AES-GCM', iv }, key, data)
  const encrypted = new Uint8Array(encryptedBuffer)
  const packed = new Uint8Array(iv.length + encrypted.length)
  packed.set(iv, 0)
  packed.set(encrypted, iv.length)
  return `${ENCRYPTION_PREFIX}${bytesToBase64(packed)}`
}

export async function decryptSyncJson(cipherText: string): Promise<string> {
  if (!cipherText) return cipherText
  if (!cipherText.startsWith(ENCRYPTION_PREFIX)) {
    return cipherText
  }
  if (!getPassphrase()) {
    return cipherText
  }
  const key = await getAesKey()
  const packed = base64ToBytes(cipherText.slice(ENCRYPTION_PREFIX.length))
  const iv = packed.slice(0, IV_LENGTH)
  const encrypted = packed.slice(IV_LENGTH)
  const decryptedBuffer = await crypto.subtle.decrypt({ name: 'AES-GCM', iv }, key, encrypted)
  return new TextDecoder().decode(decryptedBuffer)
}
